<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M29.1121 5.12338C30.2835 3.95205 30.2835 2.04982 29.1121 0.878494C27.9408 -0.292831 26.0386 -0.292831 24.8672 0.878494L15 10.7551L5.12338 0.887865C3.95205 -0.283461 2.04982 -0.283461 0.878494 0.887865C-0.292831 2.05919 -0.292831 3.96142 0.878494 5.13275L10.7551 15L0.887865 24.8766C-0.283461 26.0479 -0.283461 27.9502 0.887865 29.1215C2.05919 30.2928 3.96142 30.2928 5.13275 29.1215L15 19.2449L24.8766 29.1121C26.0479 30.2835 27.9502 30.2835 29.1215 29.1121C30.2928 27.9408 30.2928 26.0386 29.1215 24.8672L19.2449 15L29.1121 5.12338Z"
      fill="currentColor"
    />
  </svg>
</template>
